export const ACTIONS = {
  FETCH_COUPON_VOUCHER_OFFERS: 'FETCH_COUPON_VOUCHER_OFFERS',
  FETCH_COUPON_VOUCHER_OFFERS_FAILURE: 'FETCH_COUPON_VOUCHER_OFFERS_FAILURE',
  FETCH_BANK_OFFERS: 'FETCH_BANK_OFFERS',
  FETCH_BANK_OFFERS_FAILURE: 'FETCH_BANK_OFFERS_FAILURE'
};
